import { render, staticRenderFns } from "./Chip.vue?vue&type=template&id=4488cec7&scoped=true&"
import script from "./Chip.vue?vue&type=script&lang=ts&"
export * from "./Chip.vue?vue&type=script&lang=ts&"
import style0 from "./Chip.vue?vue&type=style&index=0&id=4488cec7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4488cec7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsCross24px: require('/var/www/packages/theme/components/icons/cross/Cross24px.vue').default})
